import {
  Box,
  Table,
  Text,
} from "@chakra-ui/react";
import { formatNumber } from "../../store/helpers";
import LineGraph from "../LineGraph";
import {
  ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS,
  sortReportRows,
} from "../../store/renderConfig";

const ARRIVAL_RATES_PER_SERVICE_CHART_HEIGHT = "220px";
const formatDecimal = (value) => Number(value || 0).toFixed(2);

export const renderOrganizationArrivalRatesPerServiceCell = (serviceData, columnId) => {
  if (columnId === "serviceName") return serviceData.serviceName;
  if (columnId === "total") return formatNumber(serviceData.total);
  if (columnId === "percentage") return `${Number(serviceData.totalPct || 0).toFixed(2)}%`;
  if (columnId === "average") return formatDecimal(serviceData.average);
  if (columnId === "min") return formatNumber(serviceData.min);
  if (columnId === "max") return formatNumber(serviceData.max);
  return null;
};

const ServiceArrivalRatesTable = ({
  index,
  serviceData,
  reportIndex,
  renderConfig,
}) => {
  const {
    total,
    serviceName,
    hasData,
    chart
  } = serviceData;
  const heading = `${serviceName}`;
  const title = `${reportIndex || ""}.${index + 1}. ${heading}`;
  if (!renderConfig?.charts?.enabled) {
    const rows = sortReportRows([serviceData], renderConfig, {
      columnDefinitions: ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS,
    });
    const visibleColumns = ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS.filter((column) =>
      renderConfig.columns.includes(column.id)
    );
    return (
      <Box className="reportTableContainer arrivalRatesPerServiceBlock">
        <Table.Root className={`stripedTable reportDataTable reportDataTable--${renderConfig.density}`} size="sm">
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeader>#</Table.ColumnHeader>
              {visibleColumns.map((column) => (
                <Table.ColumnHeader key={column.id}>{column.label}</Table.ColumnHeader>
              ))}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {rows.map((row, rowIndex) => (
              <Table.Row key={`${row.serviceName}-${rowIndex}`}>
                <Table.Cell>{rowIndex + 1}</Table.Cell>
                {visibleColumns.map((column) => (
                  <Table.Cell key={column.id}>
                    {renderOrganizationArrivalRatesPerServiceCell(row, column.id)}
                  </Table.Cell>
                ))}
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Root>
      </Box>
    );
  }

  return (
    <Box key={index} className="reportContainer arrivalRatesPerServiceChartBlock" mt="20px">
      <h3>
        {title}
        {!hasData && (
          <Text fontSize="sm">No data available for this report</Text>
        )}
      </h3>

      <Box>
        {total ? (
          <Box mt="16px" mb="20px">
            <LineGraph
              chart={chart}
              height={ARRIVAL_RATES_PER_SERVICE_CHART_HEIGHT}
              title={`Entire Organization: ${serviceName} Arrival Rates, Day by Day Comparison`}
            />
          </Box>
        ) : (
          <></>
        )}
      </Box>
    </Box>
  );
};

export default ServiceArrivalRatesTable;
